import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-boolean-field',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './boolean-field.component.html',
  styleUrl: './boolean-field.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooleanFieldComponent {
  @Input() label: string = '';
  @Input({ transform: booleanAttribute}) value: boolean = false;
  @Input() trueText: string = 'SI';
  @Input() falseText: string = 'NO';
  @Input() trueIcon: string = 'done';
  @Input() falseIcon: string = 'close';
  @Input() trueColor: string = 'text-green-400';
  @Input() falseColor: string = 'text-red-400';
  @Input({ transform: booleanAttribute }) withIcon: boolean = false;
  @Input({ transform: booleanAttribute }) vertical: boolean = false;
}
